import ContactUs from 'components/ContactUs/ContactUs.component';

const ContactUsPage = () => {
	return <ContactUs />;
};

export default ContactUsPage;
